import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mf_confirm_dialog = _resolveComponent("mf-confirm-dialog");
  return _openBlock(), _createBlock(_component_mf_confirm_dialog, {
    modelValue: $data.open,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.open = $event),
    title: $props.title,
    "confirm-text": $props.confirmText,
    "cancel-text": $props.cancelText,
    "confirm-color": $props.confirmColor,
    "cancel-color": $props.cancelColor,
    message: $props.message,
    "hide-cancel": $props.hideCancel,
    dark: "",
    onConfirm: $options.onConfirm,
    onCancel: $options.onCancel
  }, null, 8, ["modelValue", "title", "confirm-text", "cancel-text", "confirm-color", "cancel-color", "message", "hide-cancel", "onConfirm", "onCancel"]);
}